export default defineNuxtPlugin(() => {
  document.addEventListener('click', (e) => {
    const header = e.target.closest('.accordion-header');
    if (header) {
      header.closest('.accordion-item')?.classList.toggle('active');
    }
  });
});
